function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    @media (min-width: ",
        "px) {\n      ",
        "\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    @media (min-width: ",
        "px) and (max-width: ",
        "px) {\n      ",
        "\n    }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import { css } from 'styled-components';
var BreakpointWidth = {
    xs: [
        0,
        575
    ],
    sm: [
        576,
        767
    ],
    md: [
        768,
        991
    ],
    lg: [
        992,
        1199
    ],
    xl: [
        1200,
        3999
    ]
};
export var mediaBreakpointUp = function(breakpoint, args) {
    return css(_templateObject(), BreakpointWidth[breakpoint][0], css.apply(void 0, _to_consumable_array(args)));
};
export var mediaBreakpointDown = function(breakpoint, args) {
    return "@media (max-width: ".concat(BreakpointWidth[breakpoint][1], "px)");
};
export var mediaBreakpointBetween = function(breakpointLower, breakpointUpper, args) {
    return css(_templateObject1(), BreakpointWidth[breakpointLower][0], BreakpointWidth[breakpointUpper][1], css.apply(void 0, _to_consumable_array(args)));
};
